import React from 'react';

import ChartReport from 'components/charts/Chart';
import { GENDER_CHART } from 'constants/charts';

const GenderAnswersReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ChartReport
        titleText="How did each gender answer the question?"
        category="gender"
        chartType="column"
        colors={GENDER_CHART}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        height={315}
        containerClassName="w-100"
      />
    </div>
  );
};

export default GenderAnswersReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/genderAnswersReport.js